import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const tariffPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.update, Actions.create, Actions.delete], subject: Models.Tariff },
    { actions: [Actions.read], subject: Models.Tariffs },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.update, Actions.create, Actions.delete], subject: Models.Tariff },
    { actions: [Actions.read], subject: Models.Tariffs },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.update, Actions.create, Actions.delete], subject: Models.Tariff },
    { actions: [Actions.read], subject: Models.Tariffs },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Tariff },
    { actions: [Actions.read], subject: Models.Tariffs },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
